export const featureConfigKeys = {
  feature_drip_7d: 'feature_drip_7d',
  feature_drip_14d: 'feature_drip_14d',
  feature_drip_30d: 'feature_drip_30d',
} as const;

export type FeatureConfigKey = keyof typeof featureConfigKeys;
export type FeatureConfigMap = Record<string, Record<string, unknown>>;

// Specific feature config types as we add them
export interface DripFeatureConfig {
  offer_id?: string;
}
